import { Col, Row } from "react-bootstrap";
import React from "react";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import { translateGeneral } from "utils/localizations";
import type { IApprovable } from "entities/types";
import ApprovalRole from "entities/approvalRole";

export default function ApprovalStatusColumn<TModel extends IApprovable>(
  approvalCheck: (item: TModel, approver: ApprovalRole) => boolean,
  approvalType: any
): ColumnDefinition<TModel> {
  const styleForApprovalIndicator = (item: TModel, approver: ApprovalRole) => {
    return (
      "rounded font-weight-bold py-2 px-3 mx-1 my-1 " +
      (approvalCheck(item, approver) ? "btn-success text-success" : "border-0 bg-transparent text-muted")
    );
  };

  const approvalTypes = Object.values(approvalType);

  return {
    title: translateGeneral("approvals"),
    valueFormatter: ({ item }: { item: TModel }) => (
      <Row className="d-flex flex-nowrap text-center">
        {approvalTypes.includes(ApprovalRole.FactualAuditor) && (
          <Col className={styleForApprovalIndicator(item, ApprovalRole.FactualAuditor)}>
            {translateGeneral(`approvalRoleIndicator.${ApprovalRole.FactualAuditor}`)}
          </Col>
        )}
        {approvalTypes.includes(ApprovalRole.CommandOperator) && (
          <Col className={styleForApprovalIndicator(item, ApprovalRole.CommandOperator)}>
            {translateGeneral(`approvalRoleIndicator.${ApprovalRole.CommandOperator}`)}
          </Col>
        )}
        {approvalTypes.includes(ApprovalRole.ChiefAccountant) && (
          <Col className={styleForApprovalIndicator(item, ApprovalRole.ChiefAccountant)}>
            {translateGeneral(`approvalRoleIndicator.${ApprovalRole.ChiefAccountant}`)}
          </Col>
        )}
      </Row>
    ),
  };
}
